import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useSearch, useMangaList } from '../api/useManga'
import { useAuthStore } from '../store/authStore'
import { useDebounce } from '../hooks/useDebounce'
import { useNoIndex } from '../hooks/useNoIndex'
import MangaGrid from '../components/manga/MangaGrid'

export default function Search() {
  useNoIndex()
  const [searchParams, setSearchParams] = useSearchParams()
  const [query, setQuery] = useState(searchParams.get('q') || '')
  const debounced = useDebounce(query, 300)
  const showAdult = useAuthStore((s) => s.user?.show_adult ?? false)

  const { data: searchData, isLoading: isSearching } = useSearch(debounced)
  const { data: popularData, isLoading: isLoadingPopular } = useMangaList({ sort: 'rating', limit: 12, show_adult: showAdult })

  const items = debounced ? (searchData || []) : (popularData?.items || popularData || [])
  const isLoading = debounced ? isSearching : isLoadingPopular

  useEffect(() => {
    setSearchParams(debounced ? { q: debounced } : {}, { replace: true })
  }, [debounced, setSearchParams])

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
      <div className="max-w-2xl mx-auto mb-8">
        <div className="relative">
          <svg className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted"
            fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input
            autoFocus
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Поиск манги..."
            className="w-full pl-12 pr-4 py-3.5 rounded-2xl text-base outline-none transition-colors bg-surface text-fg border border-line focus:border-accent"
          />
          {query && (
            <button onClick={() => setQuery('')}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-xl leading-none text-muted hover:text-fg transition-colors">
              ×
            </button>
          )}
        </div>
      </div>

      <div>
        <h2 className="text-lg font-bold mb-4">
          {query ? <>Результаты для «{query}»</> : 'Популярные тайтлы'}
        </h2>
        {!isLoading && query && items.length === 0 ? (
          <div className="py-16 text-center">
            <p className="text-xl mb-2">Ничего не найдено</p>
            <p className="text-sm text-muted">Попробуйте другое название или воспользуйтесь каталогом</p>
          </div>
        ) : (
          <MangaGrid items={items} loading={isLoading} count={12} />
        )}
      </div>
    </div>
  )
}
